<template>
  <div class="suborg-list-page">
    <div class="suborg-list-container">
      <div v-if="pagedSubOrgs.length > 0" class="suborg-list">
        <div
          class="suborg-row"
          v-for="(subOrg, index) in pagedSubOrgs"
          :key="rowKey(subOrg, index)"
          :class="{ 'is-expanded': isExpanded(subOrg, index) }">
          <div class="suborg-row-main" :class="{ 'is-embedded': embedded }" @click="toggleExpand(subOrg, index)">
            <div class="suborg-title-col">
              <div
                class="suborg-avatar"
                :class="{ 'has-logo': subOrgLogo(subOrg) }"
                :style="subOrgLogo(subOrg) ? null : { background: avatarColor(index) }">
                <img
                  v-if="subOrgLogo(subOrg)"
                  :src="subOrgLogo(subOrg)"
                  :alt="subOrg.title || ''">
                <span v-else>{{ initials(subOrg.title) }}</span>
              </div>
              <span class="suborg-title ace_sec_txt">{{ subOrg.title }}</span>
            </div>
            <div class="suborg-meta-col suborg-location ace_sec_txt" v-if="!embedded">
              <span class="icon-location" aria-hidden="true"></span>
              <span class="suborg-meta-text">{{ displayValue(subOrg.address) }}</span>
            </div>
            <div class="suborg-meta-col suborg-contact ace_sec_txt">
              <span class="icon-user" aria-hidden="true"></span>
              <span class="suborg-meta-text">{{ contactLabel(subOrg) }}</span>
            </div>
            <button
              type="button"
              class="expand-btn"
              :class="{ 'is-open': isExpanded(subOrg, index) }"
              :aria-expanded="isExpanded(subOrg, index) ? 'true' : 'false'"
              :aria-label="isExpanded(subOrg, index) ? ('collapse ' + getSubOrgLabel) : ('expand ' + getSubOrgLabel)"
              @click.stop="toggleExpand(subOrg, index)">
              <span class="fa fa-angle-down"></span>
            </button>
          </div>
          <div class="suborg-row-details" v-if="isExpanded(subOrg, index)">
            <div class="suborg-details-actions" v-if="showEdit">
              <b-button class="status-update-btn" @click="goToEdit(subOrg)">Edit</b-button>
            </div>
            <div class="employer-header-row" :class="{ 'has-logo': subOrgLogo(subOrg) }">
              <div class="employer-logo" v-if="subOrgLogo(subOrg)">
                <img :src="subOrgLogo(subOrg)" :alt="subOrg.title || ''"/>
              </div>
              <div class="employer-meta-item">
                <div class="icon_container">
                  <span class="ic2_url" aria-hidden="true"></span>
                </div>
                <div class="ace_sec_txt">
                  <b-link
                    v-if="website(subOrg)"
                    :href="website(subOrg)"
                    :title="subOrg.title"
                    target="_blank">
                    {{ subOrg.title }}
                  </b-link>
                  <span v-else>{{ $t('na') }}</span>
                </div>
              </div>
              <div class="employer-meta-item">
                <div class="icon_container">
                  <span class="icon-mail" aria-hidden="true"></span>
                </div>
                <div class="ace_sec_txt address-text">{{ displayValue(subOrg.email) }}</div>
              </div>
              <div class="employer-meta-item">
                <div class="icon_container">
                  <span class="icon-location" aria-hidden="true"></span>
                </div>
                <div class="ace_sec_txt">{{ displayValue(subOrg.city) }}</div>
              </div>
              <div class="employer-meta-item">
                <div class="icon_container">
                  <span class="icon-map" aria-hidden="true"></span>
                </div>
                <div class="ace_sec_txt">{{ displayValue(subOrg.state) }}</div>
              </div>
              <div class="employer-meta-item">
                <div class="icon_container">
                  <span class="ico-map" aria-hidden="true"></span>
                </div>
                <div class="ace_sec_txt">{{ displayValue(subOrg.country) }}</div>
              </div>
              <div class="employer-meta-item">
                <div class="icon_container">
                  <span class="icon-phone" aria-hidden="true"></span>
                </div>
                <div class="ace_sec_txt">{{ displayValue(subOrg.phone) }}</div>
              </div>
              <div class="employer-meta-item">
                <div class="icon_container">
                  <span class="icon-phone" aria-hidden="true"></span>
                </div>
                <div class="ace_sec_txt">{{ displayValue(subOrg.fax) }}</div>
              </div>
              <div class="employer-meta-item">
                <div class="icon_container">
                  <span class="icon-location" aria-hidden="true"></span>
                </div>
                <div class="ace_sec_txt address-text">{{ displayValue(subOrg.address) }}</div>
              </div>
            </div>
            <div class="employer-meta-row description_row ace_sec_txt">
              <div class="employer-meta-item employer-description-item">
                <div class="icon_container">
                  <span class="ic ic2_description" aria-hidden="true"></span>
                </div>
                <div>
                  <h2 class="head_txt module_type_name ace_sec_hd">
                    {{ $t('description') }}
                  </h2>
                </div>
              </div>
            </div>
            <div class="job-meta-row description_row ace_sec_txt">
              <div class="employer-meta-item employer-description-item">
                <div class="job-description" v-if="subOrg.description" v-html="subOrg.description"></div>
                <div v-else class="no-description">{{ $t('noDescriptionForSchool', { label: getSubOrgLabel }) }}</div>
              </div>
            </div>
            <template v-if="subOrg.mission">
            <div class="employer-meta-row description_row ace_sec_txt">
              <div class="employer-meta-item employer-description-item">
                <div class="icon_container">
                  <span class="ic ic2_description" aria-hidden="true"></span>
                </div>
                <div>
                  <h2 class="head_txt module_type_name ace_sec_hd">
                    {{ $t('mission') }}
                  </h2>
                </div>
              </div>
            </div>
            <div class="job-meta-row description_row ace_sec_txt" >
              <div class="employer-meta-item employer-description-item">
                <div class="job-description"  v-html="subOrg.mission"></div>
                
              </div>
            </div>
            </template>
            <div class="employer-header-row social-row" v-if="hasSocialLinks(subOrg)">
              <div class="employer-meta-item" v-if="subOrg.youtubeUri">
                <div class="icon_container">
                  <span class="ic2_url" aria-hidden="true"></span>
                </div>
                <div class="ace_sec_txt">
                  <b-link :href="subOrg.youtubeUri" target="_blank">{{ $t('youtube') }}</b-link>
                </div>
              </div>
              <div class="employer-meta-item" v-if="subOrg.facebookUri">
                <div class="icon_container">
                  <span class="ic2_url" aria-hidden="true"></span>
                </div>
                <div class="ace_sec_txt">
                  <b-link :href="subOrg.facebookUri" target="_blank">{{ $t('facebook') }}</b-link>
                </div>
              </div>
              <div class="employer-meta-item" v-if="subOrg.linkedinUri">
                <div class="icon_container">
                  <span class="ic2_url" aria-hidden="true"></span>
                </div>
                <div class="ace_sec_txt">
                  <b-link :href="subOrg.linkedinUri" target="_blank">{{ $t('linkedin') }}</b-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="no-result ace_sec_txt">{{ $t('noResult') }}</div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import '../../../assets/module/css/job/jobHomepage.min.css'
  import employerSettingsFlags from '../employerSettingsFlags'

  export default {
    name: 'subOrgList',
    mixins: [employerSettingsFlags],
    props: {
      parentId: {
        type: String,
        default: ''
      },
      showEdit: {
        type: Boolean,
        default: false
      },
      embedded: {
        type: Boolean,
        default: false
      },
      search: {
        type: String,
        default: ''
      },
      page: {
        type: Number,
        default: 0
      },
      pageSize: {
        type: Number,
        default: 10
      }
    },
    data () {
      return {
        subOrgs: [],
        expandedKey: null,
        avatarColors: ['#e08a4a', '#3d5a99', '#9b8ac4', '#4a7c8c']
      }
    },
    mounted () {
      this.loadSubOrgs()
    },
    methods: {
      ...mapActions([
        'loadSubOrganizationsByParent'
      ]),
      loadSubOrgs () {
        if (!this.parentId) {
          this.subOrgs = []
          this.expandedKey = null
          this.emitPaging()
          return
        }
        this.loadSubOrganizationsByParent(this.parentId).then((res) => {
          this.subOrgs = this.normalizeList(res)
          this.expandedKey = null
          this.emitPaging()
        })
      },
      normalizeList (res) {
        if (!res) {
          return []
        }
        if (Array.isArray(res)) {
          return res
        }
        if (Array.isArray(res.data)) {
          return res.data
        }
        if (Array.isArray(res.subOrganizations)) {
          return res.subOrganizations
        }
        return []
      },
      rowKey (subOrg, index) {
        if (!subOrg) {
          return index
        }
        return subOrg.uuid || subOrg.id || index
      },
      isExpanded (subOrg, index) {
        return this.expandedKey === this.rowKey(subOrg, index)
      },
      toggleExpand (subOrg, index) {
        let key = this.rowKey(subOrg, index)
        this.expandedKey = this.expandedKey === key ? null : key
      },
      subOrgLogo (subOrg) {
        return (subOrg && subOrg.logo) || ''
      },
      website (subOrg) {
        return (subOrg && (subOrg.website || subOrg.uri)) || ''
      },
      contactName (subOrg) {
        if (!subOrg) {
          return this.$t('na')
        }
        return subOrg.contanctName || subOrg.contactName || this.$t('na')
      },
      contactTitle (subOrg) {
        if (!subOrg) {
          return this.$t('na')
        }
        return subOrg.contanctTitle || subOrg.contactTitle || this.$t('na')
      },
      contactLabel (subOrg) {
        let title = (subOrg && (subOrg.contanctTitle || subOrg.contactTitle)) || ''
        let name = (subOrg && (subOrg.contanctName || subOrg.contactName)) || ''
        if (title && name) {
          return title + ': ' + name
        }
        if (title || name) {
          return title || name
        }
        return this.$t('na')
      },
      displayValue (value) {
        return value || this.$t('na')
      },
      initials (title) {
        if (!title) {
          return ''
        }
        let first = title.trim().split(/\s+/)[0]
        if (first.length <= 4) {
          return first.toUpperCase()
        }
        return first.substring(0, 3).toUpperCase()
      },
      avatarColor (index) {
        return this.avatarColors[index % this.avatarColors.length]
      },
      hasSocialLinks (subOrg) {
        return !!(subOrg && (subOrg.youtubeUri || subOrg.facebookUri || subOrg.linkedinUri))
      },
      goToEdit (subOrg) {
        if (!this.parentId || !subOrg || !subOrg.uuid) {
          return
        }
        this.$router.push({
          name: 'subOrgEdit',
          params: {
            uuid: this.parentId,
            subOrgId: subOrg.uuid
          }
        })
      },
      matchesSearch (subOrg, term) {
        if (!term) {
          return true
        }
        let values = [
          subOrg.title,
          subOrg.city,
          subOrg.state,
          subOrg.country,
          subOrg.address,
          subOrg.email,
          subOrg.contanctName,
          subOrg.contactName,
          subOrg.contanctTitle,
          subOrg.contactTitle
        ]
        return values.some((value) => {
          return (value || '').toLowerCase().indexOf(term) !== -1
        })
      },
      emitPaging () {
        let total = this.filteredSubOrgs.length
        let totalPages = Math.ceil(total / this.pageSize)
        if (totalPages < 1) {
          totalPages = 1
        }
        this.$emit('paging', {
          total: total,
          firstPage: this.page <= 0,
          lastPage: this.page >= totalPages - 1
        })
      }
    },
    computed: {
      filteredSubOrgs () {
        let list = this.subOrgs || []
        let term = (this.search || '').toLowerCase()
        if (!term) {
          return list
        }
        return list.filter((subOrg) => {
          return this.matchesSearch(subOrg, term)
        })
      },
      pagedSubOrgs () {
        let start = this.page * this.pageSize
        return this.filteredSubOrgs.slice(start, start + this.pageSize)
      }
    },
    watch: {
      parentId () {
        this.loadSubOrgs()
      },
      search () {
        this.expandedKey = null
        this.emitPaging()
      },
      page () {
        this.expandedKey = null
        this.emitPaging()
      },
      pageSize () {
        this.expandedKey = null
        this.emitPaging()
      },
      filteredSubOrgs () {
        this.emitPaging()
      }
    }
  }
</script>

<style scoped>
  .suborg-list-page {
    width: 100%;
  }

  .suborg-list-container {
    width: 100%;
    min-width: 0;
    background: #fff;
  }

  .suborg-row {
    width: 100%;
    min-width: 0;
    overflow: hidden;
    border-bottom: 1px solid #e6e6e6;
  }

  .suborg-row-main {
    display: grid;
    grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr) minmax(0, 1fr) 40px;
    align-items: center;
    column-gap: 24px;
    min-height: 64px;
    width: 100%;
    min-width: 0;
    padding: 14px 8px 14px 4px;
    cursor: pointer;
  }

  .suborg-row-main.is-embedded {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) 40px;
    column-gap: 12px;
  }

  .suborg-row-main.is-embedded .suborg-avatar {
    width: 48px;
    margin-right: 8px;
  }

  .suborg-title-col {
    display: flex;
    align-items: center;
    min-width: 0;
  }

  .suborg-avatar {
    width: 80px;
    height: 32px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    color: #000;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.2px;
    overflow: hidden;
    flex-shrink: 0;
  }

  .suborg-avatar.has-logo {
    background: transparent;
  }

  .suborg-avatar img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .suborg-title {
    display: block;
    font-size: 16px;
    font-weight: 500;
    color: #4a4a4a;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .suborg-meta-col {
    display: flex;
    align-items: center;
    min-width: 0;
    font-size: 14px;
    font-weight: 400;
    color: #6a6a6a;
  }

  .suborg-meta-col .icon-location,
  .suborg-meta-col .icon-user {
    flex-shrink: 0;
    margin-right: 8px;
    font-size: 16px;
    color: #6a6a6a;
  }

  .suborg-meta-text {
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .expand-btn {
    width: 30px;
    height: 30px;
    min-width: 30px;
    min-height: 30px;
    padding: 0;
    border: 1px solid #d4d4d4;
    border-radius: 50%;
    background: #fff;
    color: #8a8a8a;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    justify-self: end;
    box-shadow: none;
    line-height: 1;
  }

  .expand-btn:hover,
  .expand-btn:focus {
    background: #f7f7f7;
    outline: none;
  }

  .expand-btn .fa {
    font-size: 16px;
    line-height: 1;
    transition: transform 0.15s ease;
  }

  .expand-btn.is-open .fa {
    transform: rotate(180deg);
  }

  .suborg-row-details {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    padding: 8px 8px 20px 4px;
  }

  .suborg-details-actions {
    display: flex;
    justify-content: flex-end;
    margin: 0 8px 12px;
  }

  .employer-header-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    column-gap: 0;
    row-gap: 18px;
    align-items: center;
    width: auto;
    min-width: 0;
    margin-left: 30px;
    margin-bottom: 16px;
  }

  .employer-header-row.has-logo {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto;
  }

  .employer-logo {
    grid-column: 3;
    grid-row: 1 / 5;
    align-self: start;
    margin: 0 0 0 24px;
  }

  .employer-header-row.has-logo .employer-address-item {
    grid-column: 2 / 4;
  }

  .employer-meta-row {
    display: grid;
    grid-template-columns: 25% 75%;
    column-gap: 0;
    align-items: center;
    width: 100%;
    margin-top: 10px;
    margin-bottom: 0;
    margin-left: 30px;
  }

  .employer-meta-item .address-text {
    white-space: nowrap;
    overflow: visible;
  }

  .employer-logo img {
    max-height: 80px;
    max-width: 240px;
    width: auto;
    height: auto;
  }

  .description_row {
    display: flex;
    grid-template-columns: none;
    min-height: 24px;
    margin-top: 16px;
    margin-bottom: 0;
  }

  .description_row .head_txt {
    width: auto;
    max-width: none;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 0;
    font-size: 18px;
    font-weight: 600;
    line-height: 28px;
    white-space: nowrap;
  }

  .employer-description-item {
    width: 100%;
    white-space: normal;
  }

  .job-description {
    width: 100%;
    display: block;
    white-space: pre-wrap;
    word-wrap: break-word;
    margin-top: 0;
    margin-bottom: 24px;
    padding-left: 4em;
    line-height: 1.5;
  }

  .job-description >>> * {
    line-height: 1.5;
  }

  .no-description {
    margin-bottom: 24px;
    padding-left: 4em;
    line-height: 1.5;
  }

  .social-row {
    margin-top: 8px;
  }

  .no-result {
    text-align: center;
    padding: 24px 8px;
  }
</style>



// WEBPACK FOOTER //
// src/app/job/components/SubOrgList.vue